module.exports = __webpack_public_path__ + "static/img/image031.0c8223e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image031.png
// module id = lyZh
// module chunks = 1